const validation = (input) => {

    let errors = {};

    if(!input.username) errors.name = 'Name Field is Required.';
    if(!input.userEmail) {
        errors.email = 'Email Field is Required.'
    } else if(!/\S+@\S+\.\S+/.test(input.userEmail)) {
        errors.email = 'Email is invalid'
    }
    if(!input.mailSubject) errors.subject = 'Email Subject Field is Required.'
    if(!input.mailMessage) errors.message = 'Message Field is Required.'

    return errors;

}

export default validation;